import { render, staticRenderFns } from "./productDes.vue?vue&type=template&id=8e29baf4&scoped=true"
import script from "./productDes.vue?vue&type=script&lang=js"
export * from "./productDes.vue?vue&type=script&lang=js"
import style0 from "./productDes.vue?vue&type=style&index=0&id=8e29baf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e29baf4",
  null
  
)

export default component.exports